import React from 'react'
import SliderWithScrollLock from '#src/components/SliderWithScrollLock'
import { Image } from '@deal/components'
import { ExpertProfilePhotoCarouselFragment } from '#src/generated/graphql'
import FallbackPhoto from './fallback.png'
import classnames from 'classnames'
import styles from './styles.css'

interface PhotoProps {
  expertProfile: ExpertProfilePhotoCarouselFragment | null
  className?: string
}

const PhotoCarousel: React.SFC<PhotoProps> = ({ expertProfile, className }) => {
  if (!expertProfile || !expertProfile.profilePhoto) {
    return null
  }

  const galleryPhotos = expertProfile.gallery.filter(photo => photo.mediaFile)

  return (
    <>
      <div className={classnames(styles.photos, className)}>
        <SliderWithScrollLock
          slidesToScroll={1}
          arrows={false}
          slidesToShow={1}
          className={styles.slider}
          autoplay={true}
          dots={true}
          appendDots={dots => {
            return (
              <div>
                <div className={styles.dots}>{dots}</div>
              </div>
            )
          }}
        >
          {galleryPhotos.length > 0 ? (
            galleryPhotos.map((photo, index) => {
              if (!photo.mediaFile) {
                return null
              }

              return (
                <div key={index} className={styles.photoContainer}>
                  <Image
                    lazyLoad={false}
                    src={photo.mediaFile.url}
                    size="100vw"
                    sizeSm="450px"
                    sizeLg="350px"
                    sizeXlg="400px"
                    className={styles.image}
                  />

                  <div
                    className={classnames(styles.gradient, {
                      [styles.hasDots]: galleryPhotos.length > 1,
                      [styles.hasCaption]: photo.caption
                    })}
                  >
                    {photo.caption && <div className={styles.caption}>{photo.caption}</div>}
                  </div>
                </div>
              )
            })
          ) : (
            <div className={styles.photoContainer}>
              <Image
                src={FallbackPhoto}
                lazyLoad={false}
                width={720}
                height={800}
                className={styles.placeholderImage}
              />
            </div>
          )}
        </SliderWithScrollLock>
      </div>
    </>
  )
}

export default PhotoCarousel
